import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Checklist, PageResponse } from '@app/models';
import { Observable } from 'rxjs';
import { BaseServiceClass } from '../baseService.service';

@Injectable({ providedIn: 'root' })
export class ChecklistServiceV2 extends BaseServiceClass<Checklist> {
  constructor(protected httpService: HttpClient) {
    super(httpService, '/api/v2/checklists');
  }

  public updateChecklistWeight(request: UpdateChecklistWeightRequest) {
    return this.httpService.patch(`${this.entity_url}/weights`, request);
  }

  public findChecklistByParentId(parentId: number) {
    return this.httpService.get<Checklist[]>(
      `${this.entity_url}/parents/${parentId}`
    );
  }

  public activateChecklist(checklistId: number) {
    return this.httpService.patch(
      `${this.entity_url}/${checklistId}/activate`,
      null
    );
  }

  public inactivateChecklist(checklistId: number) {
    return this.httpService.patch(
      `${this.entity_url}/${checklistId}/inactivate`,
      null
    );
  }

  public filterWithPagination(filter: {
    name?: string;
    segmentIds?: number[];
    active?: boolean;
    page?: number;
    linesPerPage?: number;
    orderBy?: string;
    direction?: string;
    showChecklistItems?: boolean;
    showMultipleChecklist?: boolean;
  }): Observable<PageResponse<Checklist>> {
    return this.filter(filter);
  }
}

export interface UpdateChecklistWeightRequest {
  checklistId: number;
  checklists: ChecklistWeight[];
}

export interface ChecklistWeight {
  id: number;
  weight: number; // impacto por checklist
}
